module.exports = "<router-outlet (activate)=\"onActivate($event)\"></router-outlet>\n"